// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"2f879cbc","341":"d04918e4","438":"a3d103c0","706":"0fcd3d46","726":"ad493f3e","901":"0c5de960"}[chunkId] + ".chunk.js";
};